import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import {
  BasicMetaData,
  Order,
  OrderFilterModel,
  Sort,
  TemplateExpectBackend,
  TemplateModel,
  TYPE_SEARCH
} from 'shared';
import { PaginateQuery, PaginatorModel, UUID } from 'symbols';
import { ContractModel, ContractModelExpectBackend } from '../symbols';


@Injectable()
export class ContractsService {
  public sortDefault$ = new BehaviorSubject({ sort: Sort.CREATED, order: Order.DESC });

  private readonly apiUrl = '/api/contracts';

  constructor(private http: HttpClient) {
  }

  getContractList(filter?: PaginateQuery<OrderFilterModel>): Observable<PaginatorModel<ContractModel>> {
    const params: { [key: string]: any } = {
      page: filter?.page || 1,
      limit: filter?.limit || 50,
      sortBy: `${filter?.sortBy[0][0]}:${filter?.sortBy[0][1]}`,
      typeSearch: filter?.filter?.typeSearch || TYPE_SEARCH.BY_METADATA,
      'filter.isNewEquipment': filter?.filter?.isNewEquipment,
      'filter.isUsedEquipment': filter?.filter?.isUsedEquipment
    };

    if (filter?.filter?.typeSearch === TYPE_SEARCH.BY_NUMBER) {
      params['filter.docNumber'] = +filter?.filter?.searchText || '';
    } else {
      params['search'] = filter?.filter?.searchText || '';
    }

    if (filter?.filter?.isDebt) {
      params['isDebt'] = filter?.filter?.isDebt;
    }

    return this.http.get<PaginatorModel<ContractModel>>(this.apiUrl, { params });
  }


  getContractListLazy(url: string): Observable<PaginatorModel<ContractModel>> {
    return this.http.get<PaginatorModel<ContractModel>>(url);
  }


  getContractById(id: string): Observable<ContractModel> {
    return this.http.get<ContractModel>(`${this.apiUrl}/contract/${id}`);
  }


  createContract(contract: ContractModelExpectBackend): Observable<ContractModel> {
    return this.http.post<ContractModel>(`${this.apiUrl}/`, { ...contract });
  }


  getNextMetaData(): Observable<BasicMetaData> {
    return this.http.get<BasicMetaData>(`${this.apiUrl}/next-meta-data`);
  }

  getContractTemplateList(): Observable<TemplateModel[]> {
    return this.http.get<TemplateModel[]>(`${this.apiUrl}/contract-template-list`);
  }


  updateTemplate(id: string, template: TemplateExpectBackend, name: string): Observable<TemplateModel> {
    return this.http.patch<TemplateModel>(`${this.apiUrl}/contract-template-list/${id}`, { ...template, name });
  }

  createTemplate(name: string, template: TemplateExpectBackend): Observable<TemplateModel> {
    return this.http.post<TemplateModel>(`${this.apiUrl}/contract-template-list/`, { ...template, name });
  }


  deleteTemplate(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/contract-template-list/${id}`);
  }


  updateContract(id: UUID, contract: ContractModelExpectBackend, force: boolean): Observable<ContractModel> {
    return this.http.patch<ContractModel>(`${this.apiUrl}/${id}`, { ...contract, force });
  }
}
